import { OrderStatus } from '~/services/order';
import Colors from './colors';

export const ORDER_STATUS = {
    [OrderStatus.WAITING_PAYMENT]: {
        icon: 'card',
        name: 'Pending payment',
        color: Colors.BLACK
    },
    [OrderStatus.PENDING_PAYMENT]: {
        icon: 'card',
        name: 'Pending payment',
        color: Colors.BLACK
    },
    [OrderStatus.PROCESSING]: {
        icon: 'bag-tick',
        name: 'Processing',
        color: Colors.ACCENT_BLUE_50
    },
    [OrderStatus.IN_TRANSIT]: {
        icon: 'truck-fast',
        name: 'Delivering',
        color: Colors.ACCENT_BLUE_50
    },
    [OrderStatus.DELIVERED]: {
        icon: 'tick-circle',
        name: 'Received',
        color: Colors.ACCENT_GREEN
    },
    [OrderStatus.CANCELLED]: {
        icon: 'close-circle',
        name: 'Cancel',
        color: Colors.ACCENT_RED_50
    }
};
